import {Component} from '@angular/core';
import {GtagAPIService} from "@bloomscorp/ngx-gtag";
import {IOrderConversionData} from "../interface/order-conversion-data";

@Component({
	selector: 'fb-order-thank-you',
	templateUrl: './order-thank-you.component.html',
	styleUrls: ['./order-thank-you.component.scss']
})
export class OrderThankYouComponent {

	constructor(
		private _gtag: GtagAPIService
	) {
	}

	public sendConversionInfo(data: IOrderConversionData): void {
		this._gtag.sendEventData({
				action: 'conversion',
				send_to: 'AW-669402544/MhTFCOzC_tEZELCLmb8C',
				transaction_id: data.orderId,
				currency: data.currency,
				value: data.value,
			}
		);
		this._gtag.sendEventData({
				action: 'Purchase',
				send_to: 'G-YY5WPYVGE4',
				transaction_id: data.orderId,
				currency: data.currency,
				value: data.value,
				items: data.items
			}
		);
	}

}
